import React, { useState } from 'react';
import { forgotPassword, verifySecretAnswers } from './api';

const ForgotPasswordFlow = ({ onBack, onResetSent }) => {
  const [step, setStep] = useState('email'); // email | questions | sent
  const [email, setEmail] = useState('');
  const [userData, setUserData] = useState(null);
  const [answer1, setAnswer1] = useState('');
  const [answer2, setAnswer2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const inputStyle = {
    width: '100%', padding: '10px 12px', background: 'rgba(5,5,8,0.6)',
    border: '1px solid #222230', borderRadius: '6px', color: '#ffffff',
    fontSize: '14px', outline: 'none', boxSizing: 'border-box', marginBottom: '16px',
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await forgotPassword(email);
      if (res.user_id) {
        setUserData(res);
        setStep('questions');
      } else {
        setError('No account found with that email, or account has no security questions.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAnswersSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await verifySecretAnswers({ userId: userData.user_id, answer1, answer2 });
      setStep('sent');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    width: '100%', maxWidth: '420px', background: 'rgba(17,17,25,0.75)',
    backdropFilter: 'blur(16px)', border: '1px solid #222230',
    borderRadius: '10px', padding: '36px', boxShadow: '0 24px 64px rgba(0,0,0,0.9)',
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#050508', padding: '20px' }}>
      <div style={cardStyle}>
        {step === 'email' && (
          <>
            <h2 style={{ margin: '0 0 8px 0', color: '#ffffff', fontSize: '20px' }}>Reset Password</h2>
            <p style={{ margin: '0 0 24px 0', color: '#8a8a9e', fontSize: '13px' }}>
              Enter your account email to begin.
            </p>
            <form onSubmit={handleEmailSubmit}>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address" required style={inputStyle}
                onFocus={(e) => e.target.style.borderColor = '#a336ff'}
                onBlur={(e) => e.target.style.borderColor = '#222230'} />
              {error && <p style={{ color: '#ff4466', fontSize: '13px', marginBottom: '12px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '11px', background: 'linear-gradient(135deg, #a336ff 0%, #791fd9 100%)',
                border: '1px solid #cc88ff', borderRadius: '6px', color: '#ffffff',
                fontWeight: '600', fontSize: '14px', cursor: 'pointer',
              }}>
                {loading ? 'Looking up...' : 'Continue'}
              </button>
            </form>
          </>
        )}

        {step === 'questions' && userData && (
          <>
            <h2 style={{ margin: '0 0 8px 0', color: '#ffffff', fontSize: '20px' }}>Security Questions</h2>
            <p style={{ margin: '0 0 24px 0', color: '#8a8a9e', fontSize: '13px' }}>
              Answer your security questions to receive a reset link.
            </p>
            <form onSubmit={handleAnswersSubmit}>
              <p style={{ color: '#d1d1e0', fontSize: '14px', marginBottom: '8px', fontWeight: '500' }}>
                {userData.secret_question_1}
              </p>
              <input type="text" value={answer1} onChange={(e) => setAnswer1(e.target.value)}
                placeholder="Your answer" required style={inputStyle}
                onFocus={(e) => e.target.style.borderColor = '#a336ff'}
                onBlur={(e) => e.target.style.borderColor = '#222230'} />
              <p style={{ color: '#d1d1e0', fontSize: '14px', marginBottom: '8px', fontWeight: '500' }}>
                {userData.secret_question_2}
              </p>
              <input type="text" value={answer2} onChange={(e) => setAnswer2(e.target.value)}
                placeholder="Your answer" required style={inputStyle}
                onFocus={(e) => e.target.style.borderColor = '#a336ff'}
                onBlur={(e) => e.target.style.borderColor = '#222230'} />
              {error && <p style={{ color: '#ff4466', fontSize: '13px', marginBottom: '12px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '11px', background: 'linear-gradient(135deg, #a336ff 0%, #791fd9 100%)',
                border: '1px solid #cc88ff', borderRadius: '6px', color: '#ffffff',
                fontWeight: '600', fontSize: '14px', cursor: 'pointer',
              }}>
                {loading ? 'Verifying...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}

        {step === 'sent' && (
          <>
            <h2 style={{ margin: '0 0 12px 0', color: '#00ff88', fontSize: '20px' }}>Check Your Email</h2>
            <p style={{ color: '#d1d1e0', fontSize: '14px', lineHeight: '1.6' }}>
              A password reset link has been sent to your email address. The link expires in 1 hour.
            </p>
          </>
        )}

        <button type="button" onClick={onBack} style={{
          marginTop: '20px', background: 'none', border: 'none',
          color: '#525266', fontSize: '13px', cursor: 'pointer', padding: 0,
        }}>
          ← Back to login
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordFlow;
